import { Github, Twitter, MessageCircle, Mail, FileText } from 'lucide-react';

const WHITEPAPER_PDF_URL = '/Whitepaper-Lite.pdf';

export default function Footer() {
  return (
    <footer className="relative z-10 bg-slate-900/50 backdrop-blur-sm border-t border-purple-500/20 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold text-gradient mb-4">DejaPortal</h3>
            <p className="text-gray-400 text-sm">
              100% Fair Launch Time-Travel GameFi on Base.
              <br />
              No VC — only you and us creating the timeline.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/whitepaper" className="text-gray-400 hover:text-purple-400">Whitepaper</a></li>
              <li><a href="/nodes" className="text-gray-400 hover:text-purple-400">Nodes Preview</a></li>
              <li><a href="/crowdfund" className="text-gray-400 hover:text-purple-400">Join Crowdfund</a></li>
              <li>
                <a href={WHITEPAPER_PDF_URL} download className="text-gray-400 hover:text-purple-400 inline-flex items-center gap-1">
                  <FileText className="w-4 h-4" />
                  Download Whitepaper (Lite)
                </a>
              </li>
              <li><a href="https://github.com/DejaPortal" className="text-gray-400 hover:text-purple-400">GitHub</a></li>
            </ul>
          </div>

          {/* Community & Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Community & Contact</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://discord.gg/rRBSnQsxJu" className="text-gray-400 hover:text-purple-400 inline-flex items-center gap-1"><MessageCircle className="w-4 h-4" /> Discord</a></li>
              <li><a href="https://twitter.com/DejaPortal" className="text-gray-400 hover:text-purple-400 inline-flex items-center gap-1"><Twitter className="w-4 h-4" /> Twitter</a></li>
              <li><a href="https://t.me/DejaPortal" className="text-gray-400 hover:text-purple-400">Telegram</a></li>
              <li><a href="mailto:hello@dejaportal.io" className="text-gray-400 hover:text-purple-400 inline-flex items-center gap-1"><Mail className="w-4 h-4" /> hello@dejaportal.io</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-400 hover:text-purple-400">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-purple-400">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        {/* Social icons */}
        <div className="flex items-center justify-center gap-6 mb-6">
          <a href="https://twitter.com/DejaPortal" className="text-gray-400 hover:text-purple-400 transition-colors" aria-label="Twitter">
            <Twitter className="w-6 h-6" />
          </a>
          <a href="https://discord.gg/rRBSnQsxJu" className="text-gray-400 hover:text-purple-400 transition-colors" aria-label="Discord">
            <MessageCircle className="w-6 h-6" />
          </a>
          <a href="https://github.com/DejaPortal" className="text-gray-400 hover:text-purple-400 transition-colors" aria-label="GitHub">
            <Github className="w-6 h-6" />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-500 text-sm">
          <p>© 2026 DejaPortal. All rights reserved.</p>
          <p className="mt-2">Built on <span className="text-purple-400">Base</span> · 100% Fair Launch · Community-Powered</p>
          <p className="mt-1">dejaportal.io</p>
        </div>
      </div>
    </footer>
  );
}
